const holder = {
  closePropertySelector(e) {
    if (holder.containerRef && !holder.containerRef.current?.contains(e.target)) {
      holder.internalStateSetter({ isOpen: false, pageNumber: 1 });
      holder.outlet({ residentList: holder.residentList, isOpen: false });
      document.removeEventListener("mousedown", holder.closePropertySelector)
    }
  }
};

export default {
  init: ({ residentList, isOpen, containerRef }, outlet, internalStateSetter) => {
    holder.internalStateSetter = internalStateSetter;
    holder.containerRef = containerRef;
    holder.residentList = residentList;
    holder.outlet = outlet;
    internalStateSetter({ isOpen: isOpen, pageNumber: 1 });
    if (isOpen) {
      document.addEventListener("mousedown", holder.closePropertySelector);
    } else {
      document.removeEventListener("mousedown", holder.closePropertySelector);
    }

  },
  'MultiResidentSelector.HeaderWrapper': ({ residentList, isOpen, containerRef }, outlet, internalStateSetter) => {
    holder.internalStateSetter = internalStateSetter;
    holder.containerRef = containerRef;
    holder.residentList = residentList;
    holder.outlet = outlet;
    internalStateSetter({ isOpen: !isOpen, pageNumber: 1 });
    if (isOpen) {
      document.removeEventListener("mousedown", holder.closePropertySelector);
      outlet({ residentList: residentList, isOpen: false });
    } else {
      document.addEventListener("mousedown", holder.closePropertySelector);
    }
  },
  'MultiResidentSelector.Body.Unit': ({ unit, residentList }, _, internalStateSetter) => {
    let index = residentList.findIndex(r => r.id === unit.id);
    if (index >= 0) {
      holder.residentList = residentList.filter(r => r.id !== unit.id);
      internalStateSetter({ residentList: residentList.filter(r => r.id !== unit.id) })
    } else {
      holder.residentList = [...residentList, unit]
      internalStateSetter({ residentList: [...residentList, unit] })
    }
  },
  'MultiResidentSelector.HeaderWrapper.LeftSideWrapper.Wrapper.SelectedButton': ({ resident, residentList }, outlet) => {
    outlet({ residentList: residentList.filter(r => r.id !== resident.id) });
  },
  'MultiResidentSelector.Body.LoadMore': ({ pageNumber }, _, internalStateSetter) => {
    internalStateSetter({ pageNumber: pageNumber + 1 })
  },
  'MultiResidentSelector.Body.TopWrapper.ClearAllHeader': ({ residentList, units }, _, internalStateSetter) => {
    if (residentList.length === 0) {
      holder.residentList = units;
      internalStateSetter({ residentList: units })
    } else {
      holder.residentList = [];
      internalStateSetter({ residentList: [] })
    }
  },
  'MultiResidentSelector.Body.TopWrapper.Search': ({ value }, _, internalStateSetter) => {
    internalStateSetter({ searchTerm: value, pageNumber: 1 })
  }
}